import { Card, Pagination } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { COUPON_TYPE, CouponService, ICoupon } from "service/coupon/service";

const GRADE_TYPE = {
  S: "스탠다드",
  P: "프리미엄",
};

const REGION_TYPE = {
  A: "전국",
  B: "서울/수도권",
  C: "지역구 통합",
  D: "대전/충청권",
  E: "강원도권",
  F: "경상권",
  G: "광주/전라권",
  H: "제주",
};

function Coupon() {
  const [couponList, setCouponList] = useState<ICoupon[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const getCouponList = async (page: number) => {
    const data = await CouponService.couponList(10, page);
    setCouponList(data.list);
    setTotalPages(data.totalCount);
  };

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  useEffect(() => {
    getCouponList(currentPage);
  }, [currentPage]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox my={3}>
        <Card style={{ marginTop: "24px" }}>
          <div style={{ padding: "24px 16px" }}>
            <div style={{ overflowX: "auto" }}>
              <table style={{ minWidth: "1000px", width: "100%" }}>
                <thead>
                  <tr
                    style={{
                      fontSize: "14px",
                      width: "100%",
                      textAlign: "center",
                      marginBottom: "16px",
                      fontFamily: "Pretendard",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <th>타입</th>
                    <th>쿠폰명</th>
                    <th>description</th>
                    <th>할인율(할인권)</th>
                    <th>쿠폰등록 유효기간</th>
                    <th>이용기간(이용권)</th>
                    <th>등급(이용권)</th>
                    <th>지역(이용권)</th>
                    <th>생성일</th>
                  </tr>
                </thead>
                <tbody>
                  {couponList.map((coupon: any, idx: number) => {
                    return (
                      <tr
                        key={idx}
                        style={{
                          fontSize: 12,
                          color: "#000000DE",
                          textAlign: "center",
                          fontFamily: "Pretendard",
                        }}
                      >
                        <td style={{ padding: "16px 8px" }}>
                          {COUPON_TYPE[coupon.type as keyof typeof COUPON_TYPE]}
                        </td>
                        <td style={{ padding: "16px 8px" }}>{coupon.name}</td>
                        <td style={{ padding: "16px 8px" }}>{coupon.description}</td>
                        <td style={{ padding: "16px 8px" }}>{coupon.discount_value || "-"}</td>
                        <td style={{ padding: "16px 8px" }}>
                          {coupon.valid_from} ~ {coupon.valid_to}
                        </td>
                        <td style={{ padding: "16px 8px" }}>{coupon.use_days || "-"}</td>
                        <td style={{ padding: "16px 8px" }}>
                          {GRADE_TYPE[coupon.grade as keyof typeof GRADE_TYPE]}
                        </td>
                        <td style={{ padding: "16px 8px" }}>
                          {REGION_TYPE[coupon.region_type as keyof typeof REGION_TYPE]}
                        </td>
                        <td style={{ padding: "16px 8px" }}>{coupon.create_time}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "24px" }}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="secondary"
                sx={{
                  "& .MuiPaginationItem-root": {
                    "&.Mui-selected": {
                      backgroundColor: "#1e9b6b",
                      color: "white",
                    },
                    "&.Mui-selected:hover": {
                      backgroundColor: "#1e9b6b",
                    },
                  },
                }}
              />
            </div>
          </div>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default Coupon;
